<template>
	<div>
		<layout-11
			:table_name="'Additional Job Orders'"
			:id=pageid
			:term=term
			style="width:100%;"
		></layout-11>
		<div class="nav-bar">
			<div>
				<button v-on:click="back()">Back</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADDITIONAL_JOBORDERS_PAGE,
		}
	},
	methods:{
		back(){
			router.go(-1)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/edit/Edit_Additional_Job_Orders.vue